export default __webpack_public_path__ + "static/media/right-banner.0576ab8e.png";